export default __webpack_public_path__ + "static/media/puppypawslogo.1d3eed84.jpg";